/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ActivityApiAsyncImport.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ActivityApiAsyncImport } from "./ActivityApiAsyncImport";

import { Project } from "./Project";
import { User } from "./User";

export type status = "queued" | "processing" | "successful" | "failed";

export const statusValues = { queued: 0, processing: 1, successful: 2, failed: 3 };

export abstract class ActivityApiAsyncImportModel {
    id: number;
    activitiesData: any | null;
    createdAt: Dayjs;
    errorMessage: string | null;
    jobId: string;
    projectId: number;
    result: any | null;
    status: status;
    updatedAt: Dayjs;
    userId: number | null;
    project: Project | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        activitiesData: any | null,
        createdAt: Dayjs,
        errorMessage: string | null,
        jobId: string,
        projectId: number,
        result: any | null,
        status: status,
        updatedAt: Dayjs,
        userId: number | null,
        project: Project | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.activitiesData = activitiesData;
        this.createdAt = createdAt;
        this.errorMessage = errorMessage;
        this.jobId = jobId;
        this.projectId = projectId;
        this.result = result;
        this.status = status;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.project = project;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): ActivityApiAsyncImport {
        const newObject = new ActivityApiAsyncImport(
            json["id"],
            json["activities_data"],
            dayjs(json["created_at"]).tz(timezone),
            json["error_message"],
            json["job_id"],
            json["project_id"],
            json["result"],
            json["status"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            activities_data: this.activitiesData,
            created_at: this.createdAt,
            error_message: this.errorMessage,
            job_id: this.jobId,
            project_id: this.projectId,
            result: this.result,
            status: this.status,
            updated_at: this.updatedAt,
            user_id: this.userId,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ActivityApiAsyncImport {
        const clone = Object.create(this) as ActivityApiAsyncImport;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
